import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import {Link} from "react-router-dom";

import qr_code from "../../../resources/images/qr-codes-android/kierowca.png";
import qr_code_testy from "../../../resources/images/qr-codes-android/kierowca-testy.png";
import {TopAlertInformacja} from "../../../componentsTopsa/alerty/TopAlerts";

export default class AplikacjaEbusDriver extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'AplikacjaEbusDriver'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/aplikacjeandroid', text: 'Aplikacje Android'},
                                    {addressUrl: '/aplikacjeandroid/ebus-driver', text: 'Aplikacja eBus Driver'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <Row>
                                <Col sm={12}>
                                    <h3>Aplikacja Android TOP eBus DRIVER <span className={'label label-ebus-primary'} style={{fontSize:'inherit'}}>PROD</span> </h3>
                                    <TopAlertInformacja text={"Aby pobrać aplikację zeskanuj poniższy kod QR"}/>
                                    <div className={"thumbnail"} style={{width: "300px", padding: "50px"}}>
                                        <img src={qr_code} className={"img-responsive"} style={{width: "100%"}}/>
                                    </div>
                                </Col>

                                <Col sm={12}>
                                    <a href={"http://gw1.topsa.com.pl/android/get/marcel/kierowcaMarcel/prod/"}>
                                        <code>http://gw1.topsa.com.pl/android/get/marcel/kierowcaMarcel/prod/</code>
                                    </a>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={6}>
                            <Row>
                                <Col sm={12}>
                                    <h3>Aplikacja Android TOP eBus DRIVER <span className={'label label-ebus-default'} style={{fontSize:'inherit'}}>BETA</span></h3>
                                    <TopAlertInformacja text={"Aby pobrać aplikację zeskanuj poniższy kod QR"}/>
                                    <div className={"thumbnail"} style={{width: "300px", padding: "50px"}}>
                                        <img src={qr_code_testy} className={"img-responsive"} style={{width: "100%"}}/>
                                    </div>
                                </Col>

                                <Col sm={12}>
                                    <a href={"http://gw1.topsa.com.pl/android/get/marcel/kierowcaMarcel/beta/"}>
                                        <code>http://gw1.topsa.com.pl/android/get/marcel/kierowcaMarcel/beta/</code>
                                    </a>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/aplikacjeandroid/ebus-driver/AplikacjaEbusDriver.js